import { useContext } from 'react'
import {
  ActionDependant,
  GlobalDataContext,
  TemplateContext,
  View,
  evaluateTemplateValue,
  useEvaluatedAttributes,
} from '@ea-lab/reactive-json'
import { resolveBackground } from '../utils'

/**
 * ReactiveJSON primitive — renders an element with a background style
 * resolved from one of three data shapes:
 *   {type: "color",    color: "#hex"}
 *   {type: "gradient", gradient: {angle, stops: [{color, position}, ...]}}
 *   {type: "image",    image: "url", overlay?: {color, opacity}}
 *
 * YAML usage:
 *   - type: ResolvedBackground
 *     value: ~~.background
 *     tag: section          # optional, default "div"
 *     attributes:
 *       class: "..."
 *       data-builder-field: background
 *     content: [...]
 */
export const ResolvedBackground = ({ props, path, currentData }) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)

  const value = evaluateTemplateValue({
    valueToEvaluate: props.value,
    globalDataContext,
    templateContext,
  })

  const evaluatedAttrs = useEvaluatedAttributes(props.attributes)
  const { style: userStyle, ...restAttrs } = evaluatedAttrs
  const bgStyles = resolveBackground(value)
  const mergedStyle = { ...(userStyle ?? {}), ...bgStyles }

  const Tag = props.tag ?? 'div'

  return (
    <ActionDependant {...props}>
      <Tag {...restAttrs} style={mergedStyle}>
        {props.content && (
          <View
            currentData={currentData?.content}
            datafield="content"
            path={path + '.content'}
            props={props.content}
          />
        )}
      </Tag>
    </ActionDependant>
  )
}
